import { MappedClass, MappedPropertyArray } from '@h5s/util-object';
import { DataGroupedByOwnerCorporateData } from './data-grouped-by-owner-corporate-data';
import { Department } from '../../settings/entities';

@MappedClass()
export class GetFiscalClosureParametersResponse {
  @MappedPropertyArray(() => DataGroupedByOwnerCorporateData)
  dataGroupedByOwnerCorporateData: DataGroupedByOwnerCorporateData[];

  @MappedPropertyArray(() => Department)
  departments: Department[];
}
